import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 9.03V14h12V9.03h2V5H4v4.03zM19 15H5v-4.97H1V19h22v-8.97h-4z"
}), 'WeekendSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/WeekendSharp.js
// module id = 7258
// module chunks = 2